import React from 'react';
import { copyToClipboard } from '@/utils';
import { showErrorToast, showSuccessToast } from '@/components/toast/globalToast';

interface HandoverIdFieldProps {
  id?: string | null;
  /** Defaults to the label both detail popups use. */
  label?: string;
  className?: string;
  /** Label typography, so this drops into either popup's grid unchanged. */
  labelClassName?: string;
}

/**
 * The handover id, readable and copyable.
 *
 * It is a UUID: nobody transcribes one by eye, but it is what ops paste into
 * tickets and queries, which is why both detail popups show it and why the copy
 * button is the point rather than decoration. It was a list column once — too
 * long to read there, so the list keeps it in the row's action menu instead.
 */
export const HandoverIdField: React.FC<HandoverIdFieldProps> = ({
  id,
  label = 'Handover ID',
  className = '',
  labelClassName = 'text-[12px] text-gray-400',
}) => {
  const handleCopy = async () => {
    if (!id) return;
    if (await copyToClipboard(id)) {
      showSuccessToast('Handover ID disalin', id);
      return;
    }
    showErrorToast('Gagal menyalin', 'Handover ID tidak bisa disalin');
  };

  return (
    <div className={className}>
      <div className={labelClassName}>{label}</div>
      <div className="flex items-center gap-1.5">
        <span className="font-mono text-[13px] text-gray-900 break-all">
          {id || '-'}
        </span>
        {id && (
          <button
            type="button"
            onClick={handleCopy}
            title="Copy Handover ID"
            aria-label="Copy Handover ID"
            className="shrink-0 p-1 rounded text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          >
            <i className="ri-file-copy-line text-[14px]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default HandoverIdField;
